
import { Component, Vue } from 'vue-property-decorator'

import BacLoggedInHeader from '@/templates/BacLoggedInHeader.vue'

import BacButton from '@/components/BacButton.vue'

@Component({
  components: {
    BacLoggedInHeader,
    BacButton
  }
})
export default class Admin extends Vue {
  mounted () {
    this.$store.dispatch('loadLoggedInUser')
  }
}
